/**
 * Onboarding actions SSOT (#498).
 *
 * The dismissible "Get set up" checklist that once lived here was replaced by
 * the mandatory SetupWizard (which gates the hub dashboard). What survives is
 * the single source of truth those onboarding CTAs share: the action labels +
 * routes, and the CtaLink helper. SetupWizard and the page empty states
 * (PageEmptyState) both read from here, so their deep-links can never drift.
 */

import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';

export const CHECKLIST_ACTIONS = {
  connectGithub: { label: 'Connect GitHub', to: '/settings/github' },
  indexRepo: { label: 'Index your first repo', to: '/settings/github' },
  roles: { label: 'Choose what SystemDox documents', to: '/settings/repo-roles' },
  capture: { label: 'Capture your first requirement', to: '/add' },
  invite: { label: 'Invite a teammate', to: '/settings/members' },
} as const;

export type ChecklistActionKey = keyof typeof CHECKLIST_ACTIONS;

/**
 * Router Link for console-relative targets, plain anchor for absolute
 * cross-host URLs — the hub renders these onboarding CTAs as same-origin
 * absolute URLs (launchUrl), where a relative Link would dead-end on the
 * catch-all route.
 */
export function CtaLink({
  to,
  className,
  children,
}: {
  to: string;
  className?: string;
  children: ReactNode;
}) {
  if (/^https?:/.test(to)) {
    return (
      <a href={to} className={className}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} className={className}>
      {children}
    </Link>
  );
}
